import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

export const useListVinculation = ({
  orderVinculationListAction,
  orderVinculationDetailListAction,
  orderVinculationListClean,
  orderVinculationList,
  orderVinculationDetailList,
  orderVinculationDetailListClean,
  transactionId,
  onClose,
  statusVinculationFilterAction,
  statusVinculationFilter,
  flowsVinculationFilterAction,
  flowsVinculationFilter,
  typeVinculationFilterAction,
  typeVinculationFilter,
}) => {
  const statusOptions = statusVinculationFilter?.payload || [];
  const flowsOptions = flowsVinculationFilter?.payload || [];
  const typeOptions = typeVinculationFilter?.payload || [];
  const { payload } = orderVinculationList || {};
  const { response } = orderVinculationDetailList || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(false);
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [setAction] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [isSessionModalOpen, setIsSessionModalOpen] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [loadingFraudAndChargeback] = useState(false);
  const [setSelectedRowId] = useState(null);
  const [error, setError] = useState(false);
  const [isError] = useState(false);
  const [, setIDorder] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      orderVinculationListAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      orderVinculationListClean();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, orderVinculationListAction, orderVinculationListClean]);

  useEffect(() => {
    if (orderVinculationList?.status === 200) {
      setLoading(false);
    } else if (orderVinculationList?.payload?.response?.status > 200) {
      setDialogMessage(orderVinculationList?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [orderVinculationList]);

  useEffect(() => {
    if (page === 0) {
      return;
    }

    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      orderVinculationListAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size]);
  useEffect(() => {
    if (typeof statusVinculationFilterAction === 'function') statusVinculationFilterAction();
    if (typeof flowsVinculationFilterAction === 'function') flowsVinculationFilterAction();
    if (typeof typeVinculationFilterAction === 'function') typeVinculationFilterAction();
  }, [statusVinculationFilterAction, flowsVinculationFilterAction, typeVinculationFilterAction]);
  const onSubmit = (data) => {
    // Validar que al menos un campo tenga valor (no vacío, null o undefined)
    const hasAnyValue = Object.values(data).some(
      (value) => value !== '' && value !== null && value !== undefined,
    );

    if (hasAnyValue) {
      setLoading(true);
      const filteredData = Object.fromEntries(
        Object.entries(data).filter(([, value]) => value !== ''),
      );
      setSearchParams(filteredData);
      setErrorMessage('');
      return true;
    } else {
      setLoading(false);
      setErrorMessage('Por favor, complete al menos uno de los siguientes campos');
      return false;
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row, idx) => ({
        ...row,
        id: row.id ?? row.order_id ?? idx,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setIDorder(id);
    if (id) {
      setIsDialogOpenDetails(true);
      orderVinculationDetailListAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        orderVinculationDetailListClean();
      };
    }
  };

  const handleClose = () => {
    // Si el modal de sesión está abierto, no cierres el modal principal ni limpies el estado
    if (isSessionModalOpen) {
      return;
    }
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    if (transactionId) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
    }
  };

  const Columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button
          variant='outlined'
          onClick={() => handleIdButtonClick(params.row.id)}
          sx={{
            ':hover': { color: 'white' },
            width: '200',
          }}
        >
          Ver detalle
        </Button>
      ),
    },
    {
      field: 'created',
      headerName: 'Fecha Vinculación',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'linked_up_flow',
      headerName: 'Flujo',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'linked_up_status',
      headerName: 'Status',
      width: 220,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'provider',
      headerName: 'Proveedor',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'mobile_subscriber_id',
      headerName: 'ID suscriptor',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'direct_number',
      headerName: 'Número',
      width: 220,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'internal_reference',
      headerName: 'Referencia',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'updated',
      headerName: 'Actualizado',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => convertToMexicoTime(params),
    },
  ];

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    handleConfirm,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    loadingFraudAndChargeback,
    error,
    isError,
    handleOpenPopUp: (action, rowId) => {
      setIsSessionModalOpen(true);
      setAction(action);
      setSelectedRowId(rowId);
      setOpenActionFraud(true);
    },
    setIsSessionModalOpen,
    openSessionModal: () => {
      setIsSessionModalOpen(true);
      setAction('session');
      setSelectedRowId(null);
      setOpenActionFraud(false);
    },
    closeSessionModal: () => {
      setIsSessionModalOpen(false);
      setAction(null);
      setSelectedRowId(null);
      setOpenActionFraud(false);
    },
    setLoading,
    statusOptions,
    flowsOptions,
    typeOptions,
  };
};
